<button (click)="onReportClick()"> Invia report </button>
